import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent {
  currentpath = {}
  constructor(
    private router: Router,
    private route: ActivatedRoute

  ) {


  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.currentpath = params['type'];
    });
  }

  gotohistory(page: string) {
    this.router.navigateByUrl('/history/' + page)

  }

}
